import './Navbar.css'
import { NavLink } from 'react-router-dom'
import { useState } from 'react'
import logo from "../../assets/images/logo_final.png";

function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return(
        <nav className='nav'>
            <div className="nav-container">
                <div className="nav-logo">
                    <NavLink to='/' onClick={() => {setIsMenuOpen(false);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                        }}>
                        <img src={logo} className='logoImg' alt="Business Support Logo"/>
                     </NavLink>
                </div>
                
                <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
                    <ul className="nav-list">
                        <li className="nav-item">
                            <NavLink to='/' 
                            className="nav-link" 
                            end onClick={() => { 
                            setIsMenuOpen(false);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                            }}>
                                Home
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink 
                            to='/services' 
                            className="nav-link" 
                            onClick={() => {
                            setIsMenuOpen(false);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                            }}>
                                Services
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to='/about' 
                            className="nav-link" 
                            onClick={() => {
                            setIsMenuOpen(false);
                            window.scrollTo({ top: 0, behavior: "smooth" })
                            }}>
                                About Us
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to='/contact' 
                            className="nav-link" 
                            onClick={() => {
                            setIsMenuOpen(false);
                            window.scrollTo({ top: 0, behavior: "smooth" })
                            }}>
                                Contact
                            </NavLink>
                        </li>
                    </ul>
                </div>

                <div className="nav-toggle" onClick={toggleMenu}>
                    <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
                    <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
                    <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
                </div>
            </div>
        </nav>
    )
}

export default Navbar